function isEmpty(value){
  return (value == null || value.length === 0 || value == undefined);
}


const validate = values => {
  const errors = {}

  //NUMERIC ONLY
  const numericFields = [
    "hoursDesiredPerWeek"
  ];
  numericFields.forEach(function(field){
    if(isNaN(values[field])){
      errors[field] = 'Valid Number Required';
    }
  });


  //REQUIRED
  const requiredFields = [
    "positionDesired",
    "dateAvailable",
    "hoursDesiredPerWeek",
    "availableHolidays",
    "availableDays",
    "availableEvenings",
    "availableWeekends"
  ];

  requiredFields.forEach(function(field){
    if(isEmpty(values[field])){
      errors[field] = 'Required';
    }
  });

  return errors
}

export default validate
